import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueSignaturePad from 'vue-signature-pad';
import VueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import DialogSnack from './components/dialogSnack.vue';
import JsonExcel from "vue-json-excel";
import VueExcelXlsx from "vue-excel-xlsx";
import './plugins/textfield-no-scroll';
import utils from './plugins/helpers';


Vue.component('dialog-snack', DialogSnack);
Vue.component("json-excel", JsonExcel);
Vue.use(VueExcelXlsx);


// ---------------------------------------------------------------------------
// Global snackbar
// ---------------------------------------------------------------------------
// The single source of truth for the snackbar lives in the Vuex store (state.snackbar),
// and the single <v-snackbar> that renders it lives in App.vue. Call this from anywhere
// (manual success/info messages, or a local catch that needs a custom message) instead of
// wiring up a per-component snackbar.
Vue.prototype.$snack = function(text, color = '', options = {}){
  store.commit('SHOW_SNACKBAR', { text, color, ...options })
}

// ---------------------------------------------------------------------------
// Global error-handling middleware
// ---------------------------------------------------------------------------
// Most of this app's API calls follow the convention of resolving with HTTP 200 and an
// { error } payload on failure, rather than a non-2xx status. The response interceptor below
// treats that convention (and real transport/HTTP failures) as an error, snackbars it, and
// re-throws so calling code can still catch it if it needs to do more than show a message.
// Anything that isn't caught there (client-side validation throws, non-axios errors) is picked
// up by Vue's global errorHandler (covers v-on handlers and lifecycle hooks, per Vue 2.6+) or,
// as a last resort, the window unhandledrejection listener. Duplicate messages seen by more
// than one layer are deduped in the SHOW_SNACKBAR mutation itself.
axios.defaults.withCredentials = true;
axios.interceptors.response.use(
  function axiosSuccessInterceptor(response){
    if(response && response.data && response.data.error){
      const message = utils.extractErrorMessage(response.data.error)
      console.error(response.data.error)
      store.commit('SHOW_SNACKBAR', { text: message, color: 'error' })
      return Promise.reject(response.data.error)
    }
    return response
  },
  async function axiosErrorInterceptor(err){
    if(err && err.response && err.response.status == 401){
      localStorage.removeItem('id')
      await router.push({path: '/login'})
      router.go()
      return Promise.reject(err)
    }
    if(err && err.response && err.response.status == 500){
      console.log("LICENSE ERROR DETECTED")
      localStorage.removeItem('id')
      await router.push({path: '/login'})
      router.go()
      return Promise.reject(err)
    }
    const message = utils.extractErrorMessage(err)
    console.error(err)
    store.commit('SHOW_SNACKBAR', { text: message, color: 'error' })
    return Promise.reject(err)
  }
)

Vue.config.errorHandler = function(err, vm, info){
  console.error(`Vue error (${info}):`, err)
  store.commit('SHOW_SNACKBAR', { text: utils.extractErrorMessage(err), color: 'error' })
}

window.addEventListener('unhandledrejection', function(event){
  console.error('Unhandled promise rejection:', event.reason)
  store.commit('SHOW_SNACKBAR', { text: utils.extractErrorMessage(event.reason), color: 'error' })
})

Vue.config.productionTip = false
Vue.use(VueSignaturePad)

Vue.use(VueCodemirror)

Vue.prototype.$scrollTo = (id, offset=100, behaviour='instant', addHash = false) => {
  if(offset===null) offset=100;

  const el = document.getElementById(id)
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - offset
    window.scrollTo({ top, behavior: behaviour }) // 'auto' = instant; 'smooth' = smooth scroll

    console.log(location)
    if (addHash) {
      // preserve the current Vue Router hash path
      const base = location.hash.split('#')[1] // removes extra # if present
      history.replaceState(
          null,
          '',
          `${location.origin}${location.pathname}${location.search}#${base}#${id}`
      )
    }
  }
}

Vue.prototype.$isDev = process.env.NODE_ENV === 'development'

new Vue({
  router,
  store,
  vuetify,
  VueSignaturePad,
  beforeCreate() { this.$store.commit('initialiseStore');},
  render: h => h(App)
}).$mount('#app')
